import { modalRenderer } from '~/modal/modalRendererRegistry';
import { AddMultipleLocationsModalContainer } from './addMultipleLocationsModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    AddMultipleLocations: undefined;
  }
}
modalRenderer.register('AddMultipleLocations', AddMultipleLocationsModalContainer);
